import { directive } from 'lit/async-directive.js';
import { TranslateDirective } from './translate.directive';
class TranslateUppercaseDirective extends TranslateDirective {
    render(identifier, interpolations) {
        const val = super.render(identifier, interpolations);
        return (typeof val === 'symbol') ?
            val : val.toUpperCase();
    }
}
export { TranslateUppercaseDirective };
export const translateUppercase = directive(TranslateUppercaseDirective);
